export enum Symptom {
  'Pelvic Belly Pain' = 'pelvic_belly_pain',
  'Rash Genital Area' = 'new_rash_genital_area',
  'Pain on Intercourse' = 'pain_on_intercourse',
  'Ulcer Genital Area' = 'ulcer_genital_area',
  Fever = 'fever',
  Itching = 'itching',
  Discharge = 'discharge',
  None = 'none',
}
